export default __webpack_public_path__ + "static/media/opensans-bold.c9f0a9e5.woff";